var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9181 11.4799V13.5864C14.9197 13.9818 14.7551 14.3596 14.4648 14.6269C14.1744 14.8942 13.7853 15.0263 13.3928 14.9907C11.2399 14.7559 9.17192 14.0176 7.35496 12.8351C5.66451 11.757 4.2313 10.3186 3.15712 8.6221C1.97471 6.79031 1.23888 4.70475 1.00922 2.53438C0.973873 2.14178 1.10457 1.75235 1.36937 1.46121C1.63418 1.17007 2.00873 1.00404 2.40151 1.00367H4.50043C5.20277 0.996733 5.80141 1.51342 5.89971 2.21138C5.9883 2.8855 6.15259 3.5474 6.38945 4.18445C6.58167 4.69764 6.45873 5.27618 6.07462 5.66601L5.18607 6.55775C6.18205 8.31564 7.63233 9.77115 9.38391 10.7707L10.2725 9.87897C10.6609 9.49347 11.2373 9.37009 11.7487 9.563C12.3835 9.80071 13.043 9.9656 13.7147 10.0545C14.4182 10.1541 14.9357 10.7671 14.9181 11.4799Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 4.01433C15.9998 4.38383 15.7013 4.68338 15.3331 4.68338H11.3332L9.99988 6.02149V0.669054C9.99988 0.299546 10.2983 0 10.6665 0H15.3331C15.7013 0 15.9998 0.299546 15.9998 0.669054V4.01433Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.03f0513a.svg";
export { ForwardRef as ReactComponent };